export default function EditButton(props: { href: string }) {
	return (
		<a
			href={props.href}
			className="btn btn-primary btn-circle btn-sm mr-1 editButton"
			title="Edit"
		>
			<i className="fas fa-edit"></i>
		</a>
	);
}
